module.exports = __webpack_public_path__ + "img/logosmall.76186615.svg";